var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type === "dropdown"
        ? _c("b-form-timepicker", {
            attrs: {
              placeholder: _vm.$t("insert.chooseTime"),
              locale: _vm.$i18n.locale === "tr" ? "tr-Tr" : "en-US",
              "label-no-time-selected": _vm.$t("insert.chooseTime"),
              "label-close-button": _vm.$t("insert.close"),
              "close-button-variant": "outline-danger",
              disabled: _vm.disabled
            },
            model: {
              value: _vm.selectedValue,
              callback: function($$v) {
                _vm.selectedValue = $$v
              },
              expression: "selectedValue"
            }
          })
        : _c(
            "b-input-group",
            { staticClass: "mb-3" },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "##:##",
                    expression: "'##:##'"
                  }
                ],
                attrs: {
                  id: "text-input",
                  type: "text",
                  placeholder: "HH:mm",
                  onkeypress: _vm.timeControl,
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.selectedValue,
                  callback: function($$v) {
                    _vm.selectedValue = $$v
                  },
                  expression: "selectedValue"
                }
              }),
              _vm._v(" "),
              _c(
                "b-input-group-append",
                [
                  _c("b-form-timepicker", {
                    staticClass: "form-control",
                    attrs: {
                      "button-only": "",
                      right: "",
                      "aria-controls": "text-input",
                      placeholder: _vm.$t("insert.chooseTime"),
                      locale: "tr-Tr",
                      "label-no-time-selected": _vm.$t("insert.chooseTime"),
                      "label-close-button": _vm.$t("insert.close"),
                      "close-button-variant": "outline-danger",
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.selectedValue,
                      callback: function($$v) {
                        _vm.selectedValue = $$v
                      },
                      expression: "selectedValue"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ffb243e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ffb243e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextTimePicker.vue
// module id = null
// module chunks = 